export const CUSTOM_GROUP_TYPES = {
  STANDARD: 'CG',
  BATCH_REPORT: 'BR',
};

export const BATCH_REPORT_ITEM_TYPES = {
  CUSTOM_REPORTS: 'CR',
  REPORTS: 'RP',
};

export const ReportTypes = {
  VIEW_ACCOUNT_BALANCES: 'ViewAccountBalances',
};

export const CUSTOM_GROUP_TYPE_OPTIONS = [
  { value: CUSTOM_GROUP_TYPES.STANDARD, label: 'Standard' },
  { value: CUSTOM_GROUP_TYPES.BATCH_REPORT, label: 'Batch Report' },
];
